module.exports = __webpack_public_path__ + "media/Fire.68f803ff.wav";